import { observable, ObservableMap } from 'mobx';

import { ORDER_STATUS } from 'src/constants/order';
import { OrderDeliveryType, OrderingChannelType, OrderPaymentType } from 'src/mobx/ordersHistoryStore/types';

export enum FilterModalsTypes {
  Main = 'MAIN',
  List = 'LIST',
  Date = 'DATE',
  Time = 'TIME',
}

export enum FilterPropertiesTypes {
  List = 'LIST',
  Date = 'DATE',
  Time = 'TIME',
  Boolean = 'BOOLEAN',
}

export enum AdvancedFilterProperties {
  Date = 'DATE',
  Time = 'TIME',
  OrderType = 'ORDER_TYPE',
  OrderingChannel = 'ORDERING_CHANNEL',
  PaymentMethod = 'PAYMENT_METHOD',
  Branch = 'BRANCH',
  Status = 'STATUS',
  ShowClosed = 'SHOW_CLOSED',
  SeparateAhead = 'SEPARATE_AHEAD',
}

export type ListProperties =
  | AdvancedFilterProperties.OrderType
  | AdvancedFilterProperties.Branch
  | AdvancedFilterProperties.OrderingChannel
  | AdvancedFilterProperties.PaymentMethod
  | AdvancedFilterProperties.Status;

export type NotBooleanProperties =
  | AdvancedFilterProperties.OrderType
  | AdvancedFilterProperties.Branch
  | AdvancedFilterProperties.OrderType
  | AdvancedFilterProperties.OrderingChannel
  | AdvancedFilterProperties.PaymentMethod
  | AdvancedFilterProperties.Status
  | AdvancedFilterProperties.Date
  | AdvancedFilterProperties.Time;

export type RangeProperties = AdvancedFilterProperties.Date | AdvancedFilterProperties.Time;

export type BooleanProperties = AdvancedFilterProperties.ShowClosed | AdvancedFilterProperties.SeparateAhead;

export const availableOptions = {
  [AdvancedFilterProperties.OrderType]: observable.map([
    [OrderDeliveryType.Curbside, { label: 'curbside', value: OrderDeliveryType.Curbside }],
    [OrderDeliveryType.Delivery, { label: 'txt_delivery', value: OrderDeliveryType.Delivery }],
    [OrderDeliveryType.DineIn, { label: 'dine_in', value: OrderDeliveryType.DineIn }],
    [OrderDeliveryType.Pickup, { label: 'Pickup', value: OrderDeliveryType.Pickup }],
  ]),
  [AdvancedFilterProperties.Branch]: observable.map(),
  [AdvancedFilterProperties.OrderingChannel]: observable.map([
    [OrderingChannelType.Android, { label: 'android_app', value: OrderingChannelType.Android }],
    [OrderingChannelType.App, { label: 'client_app', value: OrderingChannelType.App }],
    [OrderingChannelType.Admin, { label: 'call_centre', value: OrderingChannelType.Admin }],
    [OrderingChannelType.Careem, { label: 'Careem', value: OrderingChannelType.Careem }],
    // [OrderingChannelType.EMenu, { label: 'e_menu', value: OrderingChannelType.EMenu }],
    [OrderingChannelType.IOS, { label: 'ios_app', value: OrderingChannelType.IOS }],
    [OrderingChannelType.Jahez, { label: 'Jahez', value: OrderingChannelType.Jahez }],
    [OrderingChannelType.Kiosk, { label: 'kiosk', value: OrderingChannelType.Kiosk }],
    [OrderingChannelType.Web, { label: 'website', value: OrderingChannelType.Web }],
    [OrderingChannelType.Dook, { label: 'dook', value: OrderingChannelType.Dook }],
    [OrderingChannelType.MiniDook, { label: 'mini_aggregator', value: OrderingChannelType.MiniDook }],
    [OrderingChannelType.HungerStation, { label: 'HungerStation', value: OrderingChannelType.HungerStation }],
    [OrderingChannelType.ToYou, { label: 'ToYou', value: OrderingChannelType.ToYou }],
    [OrderingChannelType.Keeta, { label: 'Keeta', value: OrderingChannelType.Keeta }],
  ]),
  [AdvancedFilterProperties.PaymentMethod]: observable.map([
    [OrderPaymentType.Careem, { label: 'Careem', value: OrderPaymentType.Careem }],
    [OrderPaymentType.Cash, { label: 'cash', value: OrderPaymentType.Cash }],
    [OrderPaymentType.Card, { label: 'txt_credit_cart', value: OrderPaymentType.Card }],
    [OrderPaymentType.Jahez, { label: 'Jahez', value: OrderPaymentType.Jahez }],
    [OrderPaymentType.Terminal, { label: 'terminal', value: OrderPaymentType.Terminal }],
    [OrderPaymentType.DookOnline, { label: 'dook_online', value: OrderPaymentType.DookOnline }],
    [OrderPaymentType.DookCash, { label: 'dook_cash', value: OrderPaymentType.DookCash }],
    [OrderPaymentType.HungerStation, { label: 'HungerStation', value: OrderPaymentType.HungerStation }],
    [OrderPaymentType.ToYou, { label: 'ToYou', value: OrderPaymentType.ToYou }],
    [OrderPaymentType.Keeta, { label: 'Keeta', value: OrderPaymentType.Keeta }],
  ]),
  [AdvancedFilterProperties.Status]: observable.map([
    [ORDER_STATUS.PENDING, { label: `${ORDER_STATUS.PENDING}_status`, value: ORDER_STATUS.PENDING }],
    [ORDER_STATUS.ACCEPTED, { label: `${ORDER_STATUS.ACCEPTED}_status`, value: ORDER_STATUS.ACCEPTED }],
    [ORDER_STATUS.PROCESSING, { label: `${ORDER_STATUS.PROCESSING}_status`, value: ORDER_STATUS.PROCESSING }],
    [ORDER_STATUS.ASSIGNED, { label: `${ORDER_STATUS.ASSIGNED}_status`, value: ORDER_STATUS.ASSIGNED }],
    [ORDER_STATUS.WAITING_FOR_PICKUP, { label: `${ORDER_STATUS.WAITING_FOR_PICKUP}_status`, value: ORDER_STATUS.WAITING_FOR_PICKUP }],
    [ORDER_STATUS.OUT_FOR_DELIVERY, { label: `${ORDER_STATUS.OUT_FOR_DELIVERY}_status`, value: ORDER_STATUS.OUT_FOR_DELIVERY }],
    [ORDER_STATUS.RETURNED, { label: `${ORDER_STATUS.RETURNED}_status`, value: ORDER_STATUS.RETURNED }],
    [ORDER_STATUS.CANCELED, { label: `${ORDER_STATUS.CANCELED}_status`, value: ORDER_STATUS.CANCELED }],
    [ORDER_STATUS.COMPLETED, { label: `${ORDER_STATUS.COMPLETED}_status`, value: ORDER_STATUS.COMPLETED }],
    // [ORDER_STATUS.DRAFT, { label: `${ORDER_STATUS.DRAFT}_status`, value: ORDER_STATUS.DRAFT }],
    // [ORDER_STATUS.ON_HOLD, { label: `${ORDER_STATUS.ON_HOLD}_status`, value: ORDER_STATUS.ON_HOLD }],
    // [ORDER_STATUS.PICKEDUP, { label: `${ORDER_STATUS.PICKEDUP}_status`, value: ORDER_STATUS.PICKEDUP }],
    // [ORDER_STATUS.WAITING_FOR_PAYMENT, { label: `${ORDER_STATUS.WAITING_FOR_PAYMENT}_status`, value: ORDER_STATUS.WAITING_FOR_PAYMENT }],
  ]),
};

export const availableProperties = {
  [AdvancedFilterProperties.OrderType]: {
    type: FilterPropertiesTypes.List,
    title: 'order_type',
  },
  [AdvancedFilterProperties.Branch]: {
    type: FilterPropertiesTypes.List,
    title: 'Branch',
  },
  [AdvancedFilterProperties.OrderingChannel]: {
    type: FilterPropertiesTypes.List,
    title: 'ordering_channel',
  },
  [AdvancedFilterProperties.PaymentMethod]: {
    type: FilterPropertiesTypes.List,
    title: 'payment_method',
  },
  [AdvancedFilterProperties.Status]: {
    type: FilterPropertiesTypes.List,
    title: 'status',
  },
  [AdvancedFilterProperties.Date]: {
    type: FilterPropertiesTypes.Date,
    title: 'date_range',
  },
  [AdvancedFilterProperties.Time]: {
    type: FilterPropertiesTypes.Time,
    title: 'Time',
  },
  [AdvancedFilterProperties.ShowClosed]: {
    type: FilterPropertiesTypes.Boolean,
    title: 'show_closed_orders_toggle',
  },
  [AdvancedFilterProperties.SeparateAhead]: {
    type: FilterPropertiesTypes.Boolean,
    title: 'separate_ahead_orders_toggle',
  },
};

export const infoByBooleanState = {
  [AdvancedFilterProperties.ShowClosed]: { on: 'show_closed_orders_on_infotip', off: 'show_closed_orders_off_infotip' },
  [AdvancedFilterProperties.SeparateAhead]: { on: 'separate_ahead_orders_on_infotip', off: 'separate_ahead_orders_off_infotip' },
};

export type AdvancedFilterListOption = { label: string; value: string; selected?: boolean };

export const initSelectedOptionsValues = {
  [AdvancedFilterProperties.OrderType]: observable.map(),
  [AdvancedFilterProperties.Branch]: observable.map(),
  [AdvancedFilterProperties.OrderType]: observable.map(),
  [AdvancedFilterProperties.OrderingChannel]: observable.map(),
  [AdvancedFilterProperties.PaymentMethod]: observable.map(),
  [AdvancedFilterProperties.Status]: observable.map(),
};

export const initRangeValues = {
  [AdvancedFilterProperties.Date]: observable.map([
    ['from', null],
    ['to', null],
    ['preset', null],
  ]) as ObservableMap<string, null | number>,
  [AdvancedFilterProperties.Time]: observable.map([
    ['from', null],
    ['to', null],
    ['preset', null],
  ]) as ObservableMap<string, null | number>,
};

export const initBooleanValues = {
  [AdvancedFilterProperties.ShowClosed]: false,
  [AdvancedFilterProperties.SeparateAhead]: true,
};
